<template>
  <div class="">
    <v-container class="ml-10 mr-10 authcode-container">
      <p class="display-1 mt-7">디지털 상품 코드 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        등록된 디지털 상품 코드에 대한 내역을 확인 및 관리합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        고객이 디지털 상품을 결제시 설정한 SMS/메일로 코드가 자동 발송처리되며 인증완료 상태로 변경됩니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        고객 요청에 따라 재발송 처리가 가능하오니 참고해 주세요.
      </p>

      <ManageAuthCodeSearch ref="searchComponent"></ManageAuthCodeSearch>
      <ManageAuthCodeList ref="listComponent"></ManageAuthCodeList>
    </v-container>
  </div>
</template>
<style scoped>
.authcode-container {
  max-width: 90% !important;
}
</style>

<script>
import ManageAuthCodeSearch from "@/components/authservice/authcode/ManageAuthCodeSearch.vue";
import ManageAuthCodeList from "@/components/digital/ManageAuthCodeList.vue";

export default {
  data: () => ({}),
  components: {
    ManageAuthCodeSearch,
    ManageAuthCodeList,
  },
};
</script>
